import React from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';

import BrandedLandingPage from '../components/page-components/branded-landing-page';
import Layout from '../components/layout';

const BrandedLandingPageTemplateContainer = styled.div``;

const BrandedLandingPageTemplate = ({ data }) => {
    return (
        <Layout>
            <BrandedLandingPageTemplateContainer>
                <BrandedLandingPage page={data.page.edges[0].node} />
            </BrandedLandingPageTemplateContainer>
        </Layout>
    );
};

export default BrandedLandingPageTemplate;

export const query = graphql`
    query($slug: String!) {
        page: allWpPage(filter: { slug: { eq: $slug } }) {
            edges {
                node {
                    id
                    title
                    slug
                    branded_lp_acf {
                        brandedBlogHandle
                        brandedFooterHeadline
                        brandedStyles {
                            sectionTitle
                            styleItems {
                                styleBlurb
                                styleTitle
                                styleImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 600) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        brandedImageSliderSettings {
                            sectionTitle
                            brandedImageSlider {
                                image {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 600) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        brandedFooterButton {
                            title
                            url
                        }
                        brandedLpCta {
                            ctaCaption
                            ctaTitle
                            ctaIcons {
                                iconBlurb
                                iconTitle
                                iconImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 100) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                            }
                            ctaButton {
                                title
                                url
                            }
                        }
                        brandedContentRows {
                            contentRowDescription
                            contentRowTitle
                            contentRowImage {
                                localFile {
                                    childImageSharp {
                                        fluid(maxWidth: 1000) {
                                            ...GatsbyImageSharpFluid
                                        }
                                    }
                                }
                            }
                        }
                        brandedTableSettings {
                            sectionTitle
                            sectionBlurb
                            sectionFooterBlurb
                            tableHeaders {
                                headerText
                            }
                            tableBodyCells {
                                cellText
                            }
                            largeTableButton {
                                title
                                url
                            }
                            smallTableButton {
                                title
                                url
                            }
                        }
                        brandedBannerSettings {
                            bannerContent
                            bannerTitle
                            bottomTextCaption
                            bannerType
                            bottomTextHeadline
                            bannerImage {
                                localFile {
                                    childImageSharp {
                                        fluid(maxWidth: 1000, quality: 90) {
                                            ...GatsbyImageSharpFluid
                                        }
                                    }
                                }
                            }
                            bannerIcons {
                                iconImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 100) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                                iconText
                            }
                            bannerButton {
                                title
                                url
                            }
                        }
                    }
                }
            }
        }
    }
`;
